// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import InputWrapper from '../InputWrapper';

// Types
import { formikInjectedPropsTypes } from '../../../../../lib/validation/propTypes/formikPropTypes';

/**
 * @visibleName File
 */
const InputFile = ({ className, noWrapper = false, ...props }) => (
  <InputWrapper
    {...props}
    type="file"
    noWrapper={noWrapper}
    className={classnames('input-file', className)}
  />
);

InputFile.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  formikProps: formikInjectedPropsTypes.isRequired,
};

export default InputFile;
